import CustomerRatingScore from "entities/customerRatingScore";
import {
  negativeRating,
  negativeRatingDisabled,
  neutralRating,
  neutralRatingDisabled,
  positiveRating,
  positiveRatingDisabled,
  successMessage,
} from "./ratingAssets";

export const ratingTypeIcon = (rating: CustomerRatingScore, isDisabled: boolean) => {
  if (isDisabled) {
    switch (rating) {
      case CustomerRatingScore.Negative:
        return negativeRatingDisabled;
      case CustomerRatingScore.Neutral:
        return neutralRatingDisabled;
      case CustomerRatingScore.Positive:
        return positiveRatingDisabled;
    }
  }
  switch (rating) {
    case CustomerRatingScore.Negative:
      return negativeRating;
    case CustomerRatingScore.Neutral:
      return neutralRating;
    case CustomerRatingScore.Positive:
      return positiveRating;
  }
};

export const successMessageIcon = () => {
  return successMessage;
};
